import React, { useCallback, useRef, useState } from 'react'
import func from '../../services/functions';
import { useAppContext } from '../../AppContext';
import mainAxios from '../../services/mainAxios';
import { Menu } from 'primereact/menu';
import moment from 'moment';
import PdfViewer from './PdfViewer';

const useShowInvoicePdf = ({loadingIdKey="id"}={}) => {
  const [loadingPdf, setLoadingPdf] = React.useState({loading:false,key:null,id:null});
  const pdfContainer = useRef();
  const loadingPdfRef = useRef();
  const templateRefMenu=useRef()
  const [,setRefresh]=useState(null)
  const [pdfToDisplay, setPdfToDisplay] = useState(null);

  const {
    company: [fullCompany],
  } = useAppContext();

  React.useEffect(() => {
    loadingPdfRef.current = loadingPdf;
  }, [loadingPdf]);


  const getFiscPdf=({invoice,params,key="iic"})=>{
    let parsedParams = {
      iic: invoice.iic,
    }
    setLoadingPdf({key,id:invoice[loadingIdKey],loading: true});
    mainAxios
    .post("endpoint/v2/get-pdf-new", {
      object: "GetFiscPDF",
      params:params ?? parsedParams
    })
    .then((res) => {
        if (res?.data?.pdf) {
        const content = res.data
        const blob = func.blobToFile(
          func.b64toBlob(content.pdf, "application/pdf"),
          "Fisc Pdf"
        );
        const formattedDate = moment().format('YYYY-MM-DD HH:mm:ss');
        setPdfToDisplay({
          url: URL.createObjectURL(blob),
          filename:  `${content.fileName ||invoice.iic || moment().format("DD/MM/YYYY")}.pdf`
        });
        setTimeout(() => {
          if(pdfContainer?.current?.classList){
            pdfContainer.current.classList.toggle("open");
          }
        }, 0);
      }
      setLoadingPdf({key,id:invoice[loadingIdKey],loading: false});
    })
    .catch(()=>{
        setLoadingPdf({key,id:invoice[loadingIdKey],loading: false});
    })
  }

  const getEinvoicesRequest=({invoice})=>{
    setLoadingPdf({key:"eic",id:invoice[loadingIdKey],loading: true});

    mainAxios
      .post("endpoint/v2/get-pdf-new", {
        object: "GetEinvoiceFromFilesystem",
        nuis: fullCompany?.nuis,
        params: {
          iic: invoice.iic,
          tcrCode: invoice.tcrCode,
          search: "einvoice",
          dataFrom: "CIS",
        },
      },
    )
      .then((res) => {
        if (res?.data?.pdf) {
          const content=res.data
          const blob = func.blobToFile(
            func.b64toBlob(content.pdf, "application/pdf"),
            "Einvoice Pdf"
          );
          setPdfToDisplay({
            url: URL.createObjectURL(blob),
            filename:  `${content.fileName ||invoice.iic || moment().format("DD/MM/YYYY")}.pdf`
          });
          setTimeout(() => {
            if(pdfContainer?.current?.classList){
              pdfContainer.current.classList.toggle("open");
            }
          }, 0);
        }
        setLoadingPdf({key:"eic",id:invoice[loadingIdKey],loading: false});
      })
      .catch(()=>{
          setLoadingPdf({key:"eic",id:invoice[loadingIdKey],loading: false});
      })
  }

  const getTemplateMenuOptions = useCallback((currInvoice) =>{
    let companyAttributesValues = fullCompany?.companyAttributes?.find(attr => { return attr?.attribute?.param === "pdfTemplate" })?.companyAttributesValues ?? []

    let templates = companyAttributesValues?.map(attr=>{
          const params = {
            iic: currInvoice.iic ?? '',
            specificTemplate:attr.value
          }
          return {
              label:attr.value,
              command: () => { getFiscPdf({key:"iic", invoice:currInvoice,params}) },
              value:attr.value
          }
      })??[]
    return templates
  },[fullCompany?.companyAttributes])

  const checkFisc=({invoice,showTemplates=true,e})=>{
    if( showTemplates==false) {
      getFiscPdf({invoice})
      return
    }

    const templates=getTemplateMenuOptions(invoice)

    if(templates.length>1){
        setRefresh((state)=>!state)
        templateRefMenu.current.templateData=templates
        templateRefMenu.current.toggle(e)
    }else{
    const specificTemplate = templates?.[0]?.value
    if(specificTemplate){
      const params={
        iic: invoice.iic,
        specificTemplate
      }
      getFiscPdf({invoice,params})
    }else{
      getFiscPdf({invoice})
    }
  }
  }

  const getAttachmentByte=({invoice})=>{
    setLoadingPdf({key:"attachmentByte",id:invoice[loadingIdKey],loading: true});
    mainAxios
    .post("endpoint/v2/get-pdf-new", {value:invoice.attachmentId})
    .then((res) => {
        if (res?.data?.pdf) {
        const content = res.data
        const blob = func.blobToFile(
          func.b64toBlob(content.pdf, "application/pdf"),
          "Custom Invoice"
      );
      setPdfToDisplay({
        url: URL.createObjectURL(blob),
        filename:  `${content.fileName ||invoice.iic || moment().format("DD/MM/YYYY")}.pdf`
      });
      setTimeout(() => {
        pdfContainer.current.classList.toggle("open");
      }, 0);
      }
      setLoadingPdf({key:"attachmentByte",id:invoice[loadingIdKey],loading: false});

    })
    .catch(_=>{
      setLoadingPdf({key:"attachmentByte",id:invoice[loadingIdKey],loading: false});
    })
  }

  const showInvoicePdf = ({key, invoice,e,showTemplates=true}) => {
    if(e){e.preventDefault();}
    if(loadingPdfRef?.current?.key === key &&
      loadingPdfRef?.current?.loading
     ) {
        return;
    }
    if (key === "iic") {
      checkFisc({invoice,showTemplates,e})
    } else if (key === "eic") {
      getEinvoicesRequest({invoice})
    } else if (key === "id") {
      const params = {
        id: invoice.id.toString() ?? '',
        isDraftInvoice: true
      }
      getFiscPdf({invoice,params,key:"id"})
    }else if(key=="attachmentByte"){
      getAttachmentByte({invoice})
    }
  };

  const pdfEmbed = (
    <>
      <Menu model={templateRefMenu?.current?.templateData ??[]} popup ref={templateRefMenu} />
      <div className="pdf-container" ref={pdfContainer}>
        <PdfViewer
          pdfToDisplay={pdfToDisplay}
          pdfContainer={pdfContainer}
        />
      </div>
    </>
  )

  return {showInvoicePdf,loadingPdf,pdfEmbed}
}

export default useShowInvoicePdf
